<template>
    <div class="card card-round border dashboard-widget dashboard-widget--project dashboard-widget--net-cash">
        <div class="card-header"><h6 class="fw-bold mb-0 dashboard-widget__title">
            <span class="dashboard-widget__icon" v-html="sidebarSvg.projectDetails"></span>
            <span>{{ $t('Net Cash Position') }}</span>
        </h6></div>
        <div class="card-body">
            <div class="text-center">
                <h4 class="fw-bold">{{projectInfo.currencyId?.sign}} {{ ReformatNumber(data.paymentPosition) }}</h4>
                <!-- <a class="text-primary small" role="button">View Full Breakdown</a> -->
            </div>
        </div>
    </div>
</template>

<script>
import {DashboardGetProjectPaymentPosition} from '@/actions/projectActions.js'
import {ReformatNumber} from '../../helpers/utilities.js'
import { sidebarSvg } from '@/components/deluxe/DeluxeSidebar.vue'
export default {
    name : 'NetCashPosition',
    props : ['projectInfo'],
    data(){
        return {
            data : { paymentPosition : 0},
            sidebarSvg
            
        }
    },
    mounted : async function(){
        const self = this

        const response = await DashboardGetProjectPaymentPosition(self.projectInfo._id)
        if(!response)
            return
        self.data = response.data
    },
    methods :{
        ReformatNumber,
    }
    
} 
</script>
